<template>
  <div
    :class="displayClass"
    :style="{ display: displayStyle ? 'block' : 'none' }"
    v-on:click="close($event)"
    style="z-index: 9998; background-color: rgba(0,0,0,.4);"
    class="modal fade" tabindex="-1" role="dialog" aria-labelledby="codeModalLabel"
  >
    <div class="modal-dialog modal-dialog-centered px-3" v-on:click="$event.stopPropagation()" role="document">
      <div class="modal-content bg-gray rounded-lg">
        <div :style="{ display: title === '' ? 'none' : 'block' }" class="modal-header">
          <h5 class="modal-title">{{title}}</h5>
          <span @click="close($event)" class="ml-auto"><FontAwesomeIcon icon="times" class="text-danger" /></span>
        </div>
        <div class="modal-body text-center mx-5 py-5 px-2">
          <slot name="body">
            <p>{{body}}</p>
          </slot>
        </div>
        <div class="modal-footer">
          <slot name="footer">
            <button @click="confirm($event)" class="py-3 px-4 clickable bg-gray text-center d-block">
              <small>
                <FontAwesomeIcon icon="check" class="text-primary mr-2" /> <span class="text-muted">{{$t('OK')}}</span>
              </small>
            </button>
            <button @click="close($event)" class="py-3 px-4 clickable bg-gray text-center d-block">
              <small>
                <FontAwesomeIcon icon="times" class="text-primary mr-2" /> <span class="text-muted">{{$t('Cancel')}}</span>
              </small>
            </button>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  name: 'Modal',

  data () {
    return {
      displayClass: '',
      displayStyle: false
    }
  },

  props: {
    displayModal: Boolean,
    onClose: Function,
    onConfirm: Function,
    title: { type: String, default: '' },
    body: { type: String, default: '' }
  },

  watch: {
    displayModal (newVal, oldVal) {
      if (newVal === true) {
        this.displayStyle = true
        setTimeout(() => {
          this.displayClass = 'show'
        }, 100)
      } else {
        this.displayClass = ''
        setTimeout(() => {
          this.displayStyle = false
        }, 100)
      }
    }
  },

  methods: {
    close (e) {
      e.stopPropagation()
      if (this.onClose) { this.onClose() }
    },
    confirm (e) {
      if (this.onConfirm) { this.onConfirm() }
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/shared/Modal.vue